module.exports = __webpack_public_path__ + "img/wechat_official_qrcode_1000.7e498f4.png";